import { render, staticRenderFns } from "./custom-alert-component.vue?vue&type=template&id=3f206e7e&scoped=true"
import script from "./custom-alert-component.vue?vue&type=script&lang=js"
export * from "./custom-alert-component.vue?vue&type=script&lang=js"
import style0 from "./custom-alert-component.vue?vue&type=style&index=0&id=3f206e7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f206e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f206e7e')) {
      api.createRecord('3f206e7e', component.options)
    } else {
      api.reload('3f206e7e', component.options)
    }
    module.hot.accept("./custom-alert-component.vue?vue&type=template&id=3f206e7e&scoped=true", function () {
      api.rerender('3f206e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-alert-component.vue"
export default component.exports